/**
 * Retro flip countdown for collection pages
 */
(function () {
  document.querySelectorAll('[data-collection-countdown]').forEach(function (root) {
    const endDate = new Date(root.dataset.endDate);
    if (Number.isNaN(endDate.getTime())) return;

    const hoursEl = root.querySelector('[data-countdown-hours]');
    const minutesEl = root.querySelector('[data-countdown-minutes]');
    const secondsEl = root.querySelector('[data-countdown-seconds]');

    function triggerFlip(spanEl, newValue) {
      if (!spanEl || spanEl.textContent === newValue) return;

      const card = spanEl.closest('.collection-countdown__card');
      spanEl.textContent = newValue;
      if (!card) return;

      card.classList.remove('is-flipping');
      void card.offsetWidth;
      card.classList.add('is-flipping');
    }

    function updateTimer() {
      const distance = endDate.getTime() - Date.now();

      if (distance <= 0) {
        triggerFlip(hoursEl, '00');
        triggerFlip(minutesEl, '00');
        triggerFlip(secondsEl, '00');
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      triggerFlip(hoursEl, String(hours).padStart(2, '0'));
      triggerFlip(minutesEl, String(minutes).padStart(2, '0'));
      triggerFlip(secondsEl, String(seconds).padStart(2, '0'));
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
})();
